<template src="./payoutsLogs.pug" />
<style src="./payoutsLogs.scss" lang="scss" scoped></style>

<script>
import { mapState } from 'vuex'
export default {
    data: () => ({
        sorting: {}
    }),
    computed: {
        ...mapState({
            payoutLogs: (state) => state.payoutLog.payoutLogs,
            isTableLoad: (state) => state.payoutLog.isLoaded,
            pagination: (state) => state.payoutLog.pagination
        }),
        headers: function() {
            return [
                { text: 'id', value: '"withdrawId"' },
                { text: 'status', value: 'status' },
                { text: 'createdAt', value: '"createdAt"' },
                { text: 'updatedAt', value: '"updatedAt"' }
            ].map(it => Object.assign(it, {
                text: this.$vuetify.lang.t(`$vuetify.pages.PayoutLog.table.${it.text}`)
            }))
        }
    },
    watch: {
        sorting: {
            handler() {
                this.getPayoutLogsByPage()
            },
            deep: true
        }
    },
    created: function() {
        this.getPayoutLogsByPage(this.pagination.page)
    },
    methods: {
        getPayoutLogsByPage(page = 1, isScrollEnable = false) {
            this.$store.dispatch('payoutLog/getPayoutLogs', {
                page,
                column: this.sorting.sortBy,
                direction: this.sorting.descending ? 'desc' : 'asc',
                withdrawId: this.$route.params.id
            }).then(_ => {
                if (isScrollEnable) {
                    scroll(this.$refs.table)
                }
            })
        },
        onPageChange(page) {
            if (page !== this.pagination.page) {
                this.getPayoutLogsByPage(page, true)
            }
        }
    }
}
</script>
